import React from 'react';
import { SVGAttributes } from 'react';

export const PanelIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group 1">
        <path
          id="Vector"
          d="M9.24682 0.602471L9.24712 0.602772L16.897 8.2527L16.8979 8.2535C16.9469 8.30231 16.9803 8.36459 16.9939 8.43243C17.0075 8.50027 17.0006 8.57062 16.9741 8.63453C16.9476 8.69846 16.9028 8.75308 16.8452 8.79145C16.7876 8.82983 16.7199 8.85023 16.6508 8.85008H16.6497H15.7997H15.2997V9.35008V15.3C15.2997 15.9614 14.7611 16.5 14.0997 16.5H3.89978C3.23839 16.5 2.6998 15.9614 2.6998 15.3V9.35008V8.85008H2.1998H1.34992C1.34988 8.85008 1.34985 8.85008 1.34981 8.85008C1.28064 8.85004 1.21302 8.82951 1.15551 8.79107C1.09797 8.75261 1.05312 8.69796 1.02664 8.63401C1.00015 8.57007 0.993223 8.49971 1.00672 8.43183L0.51688 8.33442L1.00672 8.43183C1.02021 8.36397 1.05352 8.30163 1.10242 8.2527C1.10244 8.25268 1.10246 8.25266 1.10247 8.25264L8.75234 0.602772L8.75264 0.602471C8.78507 0.569987 8.82359 0.544216 8.86599 0.526634C8.90838 0.50905 8.95383 0.5 8.99973 0.5C9.04564 0.5 9.09108 0.509051 9.13348 0.526633C9.17588 0.544217 9.2144 0.569988 9.24682 0.602471ZM14.1005 15.8H14.6006L14.6005 15.2999L14.5997 11.0501V11.05V7.152V6.94489L14.4532 6.79845L9.35329 1.6985L8.99973 1.34494L8.64618 1.6985L3.54623 6.79845L3.39978 6.94489V7.152V15.3V15.8H3.89978H14.1005Z"
          fill="currentColor"
          stroke="currentColor"
        />
        <path
          id="Vector_2"
          d="M8.14958 9.85076H8.64958V9.35076V7.30078H9.34957V9.35076V9.85076H9.84957H11.8995V10.5507H9.84957H9.34957V11.0507V13.1007H8.64958V11.0507V10.5507H8.14958H6.09961V9.85076H8.14958Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </g>
    </svg>
  );
};

export default PanelIcon;
